import React from 'react';

interface Props {
  codes: string[];
  onClose: () => void;
}

const RecoveryCodesDisplay: React.FC<Props> = ({ codes, onClose }) => {
  const download = () => {
    const content = `Codes de récupération Macadamia\nGénérés le ${new Date().toLocaleString('fr-FR')}\n\n${codes.join('\n')}\n\nUsage unique. Conservez-les en lieu sûr.\n`;
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `macadamia-recovery-codes-${new Date().toISOString().slice(0, 10)}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const copyAll = () => {
    navigator.clipboard.writeText(codes.join('\n')).catch(() => undefined);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-mcdm-third-400 rounded-lg shadow-xl max-w-lg w-full p-6 space-y-4">
        <h2 className="text-lg font-semibold text-mcdm-third-500 dark:text-mcdm-primary-100">Vos codes de récupération</h2>
        <p className="text-sm text-mcdm-third-500 dark:text-mcdm-primary-200">
          Ces codes vous permettent de vous connecter si vous perdez l'accès à tous vos appareils biométriques.{' '}
          <strong>Chaque code n'est utilisable qu'une seule fois.</strong> Conservez-les dans un gestionnaire de mots
          de passe ou imprimez-les. Ils ne seront plus jamais affichés.
        </p>
        <div className="grid grid-cols-2 gap-2 font-mono text-sm bg-gray-50 dark:bg-mcdm-third-500 border rounded p-4">
          {codes.map((code) => (
            <div key={code} className="text-gray-800 dark:text-mcdm-primary-100">
              {code}
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={download} className="px-3 py-2 text-sm bg-mcdm-green-400 hover:bg-mcdm-green-500 text-white rounded">
            Télécharger en .txt
          </button>
          <button type="button" onClick={copyAll} className="px-3 py-2 text-sm border border-mcdm-green-400 text-mcdm-green-500 hover:bg-mcdm-green-100 rounded">
            Copier tous les codes
          </button>
          <button type="button" onClick={() => window.print()} className="px-3 py-2 text-sm border border-gray-300 text-gray-700 hover:bg-gray-50 rounded">
            Imprimer
          </button>
        </div>
        <div className="pt-3 border-t flex justify-end">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm bg-gray-900 text-white hover:bg-gray-800 rounded">
            J'ai sauvegardé mes codes
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecoveryCodesDisplay;
